import React, { useEffect } from 'react'
import { Headline } from '../../uiComponents/typography'
import { useParams } from 'react-router-dom'
import { SigmaService } from './sigmaService'
import { useHasFeature } from 'utils/useHasFeature'
import './sigmaReport.scss'
import { usePageHeight, useSigmaIframe } from '@sigmacomputing/react-embed-sdk'

interface SigmaReportProps {
    accountSlug: string
    sigmaService: SigmaService
}

export const SigmaReport = ({ accountSlug, sigmaService }: SigmaReportProps) => {
    const { iframeRef } = useSigmaIframe()
    const height = Math.ceil(usePageHeight(iframeRef) || 0)
    const [embedUrl, setEmbedUrl] = React.useState('')
    const { reportId } = useParams<{ reportId: string }>()
    const featureFlagEnabled = useHasFeature({ featureName: 'SigmaReports' })

    const fetchEmbedUrl = () => {
        sigmaService.getEmbedUrl(accountSlug, reportId).then((url) => {
            setEmbedUrl(url)
        })
    }

    useEffect(() => {
        if (!embedUrl && featureFlagEnabled) {
            fetchEmbedUrl()
        }
    })

    useEffect(() => {
        setEmbedUrl('')
    }, [featureFlagEnabled, accountSlug, reportId])

    return featureFlagEnabled ? (
        <>
            <Headline size={1}>Sigma POC</Headline>
            {embedUrl && <iframe className="sigma-iframe" ref={iframeRef} style={{ height }} src={embedUrl} />}
        </>
    ) : null
}
